import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Route, Switch } from 'react-router-dom';
import VenuesList from 'components/merchant/venues/venues-list';
import VenueForm from 'components/merchant/venues/venue-form';

const VenuesIndex = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={VenuesList} />
    <Route exact path={`${match.url}/venue/:venueId`} component={VenueForm} />
  </Switch>
)

VenuesIndex.propTypes = {
  match: PropTypes.object,
};

export default withRouter(VenuesIndex);
